import React from "react";
import "../css/LoadingUI.css";

function ValidatingLayout(){

    return(
        <div className="LoadingUI-root-container">
                <div className="LoadingUI-loader"></div>
                <p>Validating</p>
        </div>
    )
}

export default ValidatingLayout;